<template>
  <div class="component-content configuration-fork">
    <div class="component-content-scroll">
      <div class="component-content-title">Select your fork details</div>
      <option-list
        :options="forkInput"
        :target="this.results.fork"
        :inputName="'fork'"
        v-on:target-updated="updateFork"
        v-if="this.components.fork"
      ></option-list>

      <div class="color-selector mt-3" v-if="showColorSelector()">
        <ColorSelector
          :primaryColor="results.colour.primaryColor"
          :secondaryColor="results.colour.secondaryColor"
          :colors="colors"
          :componentId="this.results.fork.id"
          :componentType="'fork'"
          :results="results"
          v-on:component-color-selected="selectColor"
        ></ColorSelector>
      </div>
    </div>
    <div class="buttonset">
      <button class="btn btn-outline-dark back-button" v-on:click="goBack">
        back
      </button>
      <finish-configuration-button
        v-if="canFinishConfiguration()"
        v-on:finish-configuration="finishConfiguration"
       ></finish-configuration-button>
      <button class="btn btn-outline-dark next-button" v-on:click="goNext">
        next
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import OptionList from "../../shared/optionList.vue";
import ColorSelector from "../../shared/component-color-selector.vue";
import FinishConfigurationButton from './finish-configuration-button.vue';

Vue.component("finish-configuration-button", FinishConfigurationButton);

export default {
  name: "configuration-fork",
  data() {
    return {};
  },
  components: {
    OptionList,
    ColorSelector
  },
  props: [
    "configuratorSteps",
    "currentStep",
    "results",
    "components",
    "measures",
    "bike",
    "colors",
  ],
  computed: {
    forkInput: {
      get: function () {
        return this.components.fork[0];
      },
      set: function (e) {
        this.$emit("set-fork", e);
      },
    },
  },
  methods: {
    goNext: function () {
      if (this.bike.brake_id==2 && this.results.fork==null) {
        this.$emit('set-error', 'Please select a fork')
        return false;
      }
      /*
      if (this.results.fork!=null && this.results.fork.colour==null  && this.results.fork.id!=89) {
        this.$emit('set-error', 'Please select a fork colour')
        return false;
      }*/
      this.$emit("go-next");
    },
    goBack: function () {
      this.$emit("go-back");
    },
    updateFork: function (e) {
      this.forkInput = e;
    },
    showColorSelector: function () {
      /*
      console.log(this.results.fork);
      return false;
      */
      /*
      if (
        typeof this.results.fork != "undefined" &&
        this.results.fork != null &&
        this.results.fork.id != -1 &&
        this.results.fork.id != 89
      ) {
       //console.log(['this.results.fork != "undefined"','this.results.stem != null','this.results.stem.id']);
       //console.log([this.results.fork != "undefined",this.results.fork != null,this.results.fork.id])
        return true;
      }
      return false;
      */
      if (
        this.results.fork != null &&
        this.results.fork.is_paintable &&
        this.bike.id != 32
      ) {
       //console.log(['this.results.fork != "undefined"','this.results.stem != null','this.results.stem.id']);
       //console.log([this.results.fork != "undefined",this.results.fork != null,this.results.fork.id])
        return true;
      }
      return false;

    },

    selectColor: function (color, componentId, componentType) {
      this.$emit("component-color-selected",color,componentId,componentType);
    },
    canFinishConfiguration: function() {
      // if fork is present, we need to check if the fork is selected and has a colour
        if (this.components.fork?.length > 0)
        {
          return (
          this.results.frame !== null &&
          this.results.frame !== undefined &&
          this.results.colour !== null &&
          this.results.colour !== undefined &&
          this.results.fork !== null &&
          this.results.fork !== undefined
          );
        }
        else
        {
          // no fork, so we can finish configuration
          return (
            this.results.frame !== null &&
            this.results.frame !== undefined &&
            this.results.colour !== null &&
            this.results.colour !== undefined
          );
        }
    },
    finishConfiguration: function() {
        this.$emit("finish-configuration");
    },
  },
};
</script>

<style lang="scss" scoped>
.configuration-fork {
}
</style>

